import { useEffect, useState } from "react";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { site } from "../content/site";
import { Logo } from "./Logo";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="header-navigation"
      className={`fixed top-0 inset-x-0 z-50 transition-[background-color,border-color,box-shadow] duration-300 border-b ${
        scrolled
          ? "bg-white/85 backdrop-blur-md border-slate-200/80 shadow-[0_1px_12px_rgba(15,23,42,0.05)]"
          : "bg-transparent border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-[72px] flex items-center justify-between gap-4">
        <a href="#home" data-testid="nav-brand-logo" className="flex items-center gap-2.5 rounded-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-500 focus-visible:ring-offset-2">
          <Logo />
          <span className="font-display font-bold text-slate-900 tracking-tight text-lg leading-none">
            votanphuoc<span className="text-teal-600">.space</span>
          </span>
        </a>

        <nav aria-label="Primary" className="hidden lg:flex items-center gap-1">
          {site.nav.map((item) => (
            <a
              key={item.href}
              href={item.href}
              data-testid={item.testId}
              className="px-3.5 py-2 text-sm font-medium text-slate-600 hover:text-slate-900 rounded-full hover:bg-slate-100 transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-500"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#contact"
            data-testid="nav-contact-cta"
            className="hidden sm:inline-flex items-center gap-1.5 bg-teal-600 hover:bg-teal-700 text-white text-sm font-semibold px-5 py-2.5 rounded-full transition-all duration-200 hover:-translate-y-0.5 shadow-sm shadow-teal-600/25 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-500 focus-visible:ring-offset-2"
          >
            Contact Us
            <ArrowUpRight size={15} strokeWidth={2.5} />
          </a>
          <button
            type="button"
            data-testid="nav-mobile-toggle"
            aria-expanded={open}
            aria-label={open ? "Close menu" : "Open menu"}
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden p-2.5 rounded-full text-slate-700 hover:bg-slate-100 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-500"
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {open && (
        <nav aria-label="Mobile" data-testid="nav-mobile-menu" className="lg:hidden bg-white/95 backdrop-blur-md border-t border-slate-200/80 px-4 py-4 flex flex-col gap-1">
          {site.nav.map((item) => (
            <a
              key={item.href}
              href={item.href}
              data-testid={`${item.testId}-mobile`}
              onClick={() => setOpen(false)}
              className="px-4 py-3 text-base font-medium text-slate-700 hover:text-slate-900 hover:bg-slate-100 rounded-xl transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-500"
            >
              {item.label}
            </a>
          ))}
          <a
            href="#contact"
            data-testid="nav-contact-cta-mobile"
            onClick={() => setOpen(false)}
            className="mt-2 inline-flex items-center justify-center gap-1.5 bg-teal-600 hover:bg-teal-700 text-white font-semibold px-5 py-3 rounded-full transition-colors"
          >
            Contact Us
            <ArrowUpRight size={15} strokeWidth={2.5} />
          </a>
        </nav>
      )}
    </header>
  );
};
